export { default } from "./EditorPlaceholder";
